import React, { FC, MouseEvent } from 'react';
import styles from './nav_item_group.module.scss';

type Props = {
  onClick: (event: MouseEvent<HTMLDivElement>) => void;
};

export const NavItemGroup: FC<Props> = ({ onClick, children }) => (
  <div className={styles.container} onClick={onClick}>
    {children}
  </div>
);
